package `fun`.adaptive.ui.instruction.layout

enum class Orientation {
    Horizontal,
    Vertical
}